import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { API_KEY, API_ENDPOINTS, LANGUAGE, IMAGE_BASE_URL } from '../config/api';
import './Header.css';

const Header = () => {
    const [searchText, setSearchText] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const searchRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowResults(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSearch = async (query = searchText) => {
        if (!query.trim()) {
            setSearchResults([]);
            setShowResults(false);
            return;
        }

        try {
            const response = await axios.get(
                `${API_ENDPOINTS.SEARCH}?api_key=${API_KEY}&language=${LANGUAGE}&query=${encodeURIComponent(query)}&include_adult=false`
            );
            setSearchResults(response.data.results.slice(0, 5));
            setShowResults(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        setSearchText(value);
        if (value.length > 2) {
            handleSearch(value);
        } else {
            setSearchResults([]);
            setShowResults(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (searchText.trim()) {
            navigate(`/search/results?query=${encodeURIComponent(searchText)}`);
            setShowResults(false);
        }
    };

    const handleResultClick = (item) => {
        const path = item.media_type === 'tv' ? `/tv/id/${item.id}` : `/film/id/${item.id}`;
        navigate(path);
        setShowResults(false);
        setSearchText('');
    };

    return (
        <header className="header-container">
            <div className="container-xl">
                <div className="header-content">
                    <Link to="/" className="logo-link">
                        <img 
                            src='/images/logo_transparent.png' 
                            alt="kinolor Logo" 
                            className="logo-img"
                        />
                        <span className="logo-text">kinolor</span>
                    </Link>
                    
                    <nav className="header-nav">
                        <Link to="/" className="nav-link">Главная</Link>
                        <Link to="/genres" className="nav-link">Жанры</Link>
                    </nav>
                    
                    <div className="search-container" ref={searchRef}>
                        <Form onSubmit={handleSubmit}>
                            <InputGroup className="search-input-group">
                                <Form.Control
                                    className="search-input"
                                    type="text"
                                    placeholder="Поиск фильмов и сериалов..."
                                    value={searchText}
                                    onChange={handleInputChange}
                                    onFocus={() => searchText.length > 2 && setShowResults(true)}
                                />
                                <Button 
                                    variant="primary" 
                                    type="submit"
                                    className="search-button"
                                >
                                    🔍
                                </Button>
                            </InputGroup>
                        </Form>
                        
                        {showResults && searchResults.length > 0 && (
                            <div className="search-results-dropdown">
                                {searchResults.map((result) => (
                                    <div
                                        key={`${result.id}-${result.media_type}`}
                                        className="search-result-item"
                                        onClick={() => handleResultClick(result)}
                                    >
                                        {result.poster_path && (
                                            <img
                                                src={`${IMAGE_BASE_URL}/w92${result.poster_path}`}
                                                alt={result.title || result.name}
                                                className="search-result-poster"
                                            />
                                        )}
                                        <div className="search-result-info">
                                            <div className="search-result-title">
                                                {result.title || result.name}
                                            </div>
                                            <div className="search-result-type">
                                                {result.media_type === 'movie' ? 'Фильм' : 'Сериал'}
                                                {result.release_date && ` • ${new Date(result.release_date).getFullYear()}`}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
